import { useState } from 'react';
import { useSelector } from 'react-redux';
import { createRendicionFondos } from '../../helpers/api_helper';

const useCreateRendicionFondos = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);

    const createRendicion = async (data) => {
        setLoading(true);
        setError(null);
        try {
            const response = await createRendicionFondos({
                ...data,
                tenantId
            });
            console.log('Response from create rendicion fondos:', response);
            return { success: true, data: response };
        } catch (err) {
            const errorMessage = `Failed to create rendicion fondos: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            console.error(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { createRendicion, loading, error };
};

export default useCreateRendicionFondos;